import React from 'react';
import PlainCRUD, { defaultFields } from 'components/PlainCRUD';
import {
  deleteGiroComercioInformal,
  getGirosComercioInformales,
  patchGiroComercioInformal,
  postGiroComercioInformal,
} from 'api/empresas/giroDeComercioInformal';

// eslint-disable-next-line react/prop-types
const giroDeComercioInformal = ({ permission }) => (
  <PlainCRUD
    title="giro de Comercio en Vía Pública"
    permission={permission}
    get={getGirosComercioInformales}
    post={postGiroComercioInformal}
    patch={patchGiroComercioInformal}
    delete={deleteGiroComercioInformal}
    withoutState
    fields={[
      defaultFields.clave,
      defaultFields.descripcion,
      {
        name: 'observaciones',
        label: 'Observaciones',
        type: 'textarea',
        colWidth: 200,
        autoSize: { minRows: 3, maxRows: 4 },
      },
    ]}
  />
);

export default giroDeComercioInformal;
